import {client} from '../axios';

import {User} from "@/types/UserType";
import {ResponseError} from "@/types";
import {resolveError} from "@/data/_resolveError";

export const resendVerification = (
    success = (verified: boolean = false) => {},
    failed = (type: ResponseError, data: any) => {}
) => {
    client.post(`/verification/resend`)
        .then((response) => {
            if(response.status == 204) {
                success(true);
            }

            success();
        }).catch((error) => resolveError(error, failed));
};

export const verifyVerification = (
    id: string,
    hash: string,
    query: {},
    success = (verified: boolean = false) => {},
    failed = (type: ResponseError, data: any) => {}
) => {
    const queryString = new URLSearchParams(query).toString();

    client.post(`/email/verify/${id}/${hash}?${queryString}`)
        .then((response) => {
            if(response.status == 204) {
                success(true);
            }

            success();
        }).catch((error) => resolveError(error, failed));
};